export const getCroppedImg = async (imageSrc: string, crop: any): Promise<Blob | null> => {
  const image = new Image();

  // Check if it's a base64/data URL
  const isDataUrl = imageSrc.startsWith('data:');

  if (!isDataUrl) {
    // Only set crossOrigin and timestamp for remote URLs (S3, etc.)
    image.crossOrigin = 'anonymous';
    const timestamp = new Date().getTime();
    const separator = imageSrc.includes('?') ? '&' : '?';
    image.src = `${imageSrc}${separator}t=${timestamp}`;
  } else {
    // For base64, load as is
    image.src = imageSrc;
  }

  await new Promise((resolve, reject) => {
    image.onload = resolve;
    image.onerror = (error) => {
      console.error('Error loading image for cropping:', error);
      reject(error);
    };
  });

  const canvas = document.createElement('canvas');
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext('2d');

  if (!ctx) return null;

  ctx.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);

  return new Promise<Blob | null>((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    }, 'image/jpeg');
  });
};
